module.exports = __webpack_public_path__ + "img/Weapon_185.74ff0d97.png";